import React, { Component } from "react";
import PropTypes from "prop-types";
import Icofont from 'react-icofont';

class Footer extends Component {
    render() {
        return (
            <React.Fragment>
                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5">
                                <p className="copyright">{this.props.copyrightText}</p>
                            </div>
                            <div className="col-md-7">
                                <div className="social-icons bottom">
                                    <ul className="list-inline">
                                        <li>{this.props.socialTitle} </li>
                                        <li><a href={this.props.forumLink} rel="noopener noreferrer" target="_blank"><Icofont icon="icofont-home" /></a></li>
                                        <li><a href={this.props.facebookLink} rel="noopener noreferrer" target="_blank"><Icofont icon="icofont-facebook" /></a></li>
                                        <li><a href={this.props.instagramLink} rel="noopener noreferrer" target="_blank"><Icofont icon="icofont-instagram" /></a></li>
                                        <li><a href={this.props.twitterLink} rel="noopener noreferrer" target="_blank"><Icofont icon="icofont-twitter" /></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        );
    }
}
//Props Types
Footer.propTypes = {
    copyrightText: PropTypes.string,
    facebookLink: PropTypes.string,
    forumLink: PropTypes.string,
    instagramLink: PropTypes.string,
    twitterLink: PropTypes.string,
};

//Default Props
Footer.defaultProps = {
    copyrightText: "2019 © All Rights Reserved.",
    socialTitle: "Follow Us On:",
    facebookLink: "//facebook.com/fans.hkgolden",
    forumLink: "//forum.hkgolden.com",
    instagramLink: "//instagram.com/hkgoldenforum",
    twitterLink: "//twitter.com/hkgoldenforum"
};
export default Footer;
